import { useCallback, useState } from 'react';

export interface SaveMessage {
  type: 'success' | 'error';
  text: string;
}

/** Runs a write behind one busy flag and reports how it went in the top bar. */
export function useSaveStatus() {
  const [busy, setBusy] = useState(false);
  const [message, setMessage] = useState<SaveMessage | null>(null);

  const run = useCallback(async (write: () => Promise<string>) => {
    try {
      setBusy(true);
      setMessage(null);
      const text = await write();
      setMessage({ type: 'success', text });
      setTimeout(() => setMessage(null), 3000);
    } catch (e) {
      setMessage({ type: 'error', text: e instanceof Error ? e.message : 'Failed to save' });
    } finally {
      setBusy(false);
    }
  }, []);

  return { busy, message, run };
}
